import { createContext } from "react";

export const AlertMessageContext = createContext();
export const UserScrollPositionContext = createContext();
export const UserDataListContext = createContext();
export const DataListContext = createContext();
export const SubDataListContext = createContext();
export const ScrollPositionContext = createContext();
export const UserInfoContext = createContext();
